import cx from "ui/cx";
import styles from "./Thumbnail.module.scss";

export interface ThumbnailProps {
  size?: "tiny" | "small" | "medium" | "large";
  className?: string;
  image?: string;
  label?: string;
  color?: string; // to render a color thumbnail
}

export default function Thumbnail({ size = "small", image, label = "", color, className }: ThumbnailProps) {
  const backgroundColor = color;
  return (
    <div className={cx(styles.wrapper, styles[size], className)} title={label} style={{ backgroundColor }}>
      {image && <img src={image} alt="" loading="lazy" />}
    </div>
  );
}
